module.exports = __webpack_public_path__ + "img/chart.aa97c39.svg";